import React from 'react';
import { connect } from 'dva';

import "./index.less";
import { component_tool, framework_tool, utils_tool } from '@/tool'
 import createColumns from './columns'
 import { formatAuth } from '@/utils/commonUtils'
import { WizModal } from 'wiz-components'
let {
  WizSpin,
  WizCard,
  WizRow,
  WizCol,
  WizCollapse,
  WizButton,
  WizSearchBar,
  WizDataTable,
  WizForm,
  WizTypography
} = component_tool
let { WizContainer,WizReduxTemplate,modelUtils } = framework_tool
let { Session, getPageData, excelUtils } = utils_tool
let { Text } = WizTypography
/**
 * 第三方应用有效岗位设置
 */
class ThirdAppAuthSetting extends WizContainer {

  componentName = 'thirdAppAuthSetting';

  constructor(props) {
      
    const { history } = props;
    let record = {};
    if (history.location && history.location.pathname === '/auth/corpManager/appAuthSetting') {
        if(history.location && history.location.record){
            record = history.location.record;
            Session.set('thirdAppAuthSetting',record)
        }else{
          record = Session.get('thirdAppAuthSetting') || {};
        }
        }
    super(props);
    this.state = {
        record,
        pageKey: new Date().getTime(),
        selectedRows: 0,
        keys: [],
        editInfo:{},
        visible:false,
    }
  }
  _componentDidMount() {
  }

  propsAndStateOnChange = {
    listByPage:this._listByPageOnChange.bind(this),
    save:this._saveOnChange.bind(this),
    deleteRecord:this._deleteRecordOnChange.bind(this)
  }
  _componentDidMount = () => {
    this._selectPageInfo({ appInfoId: this.state?.record?.id || null });
  }
  _listByPageOnChange(nextProps, nextState) {
    if (nextProps['listByPage'] && nextProps['listByPage']['success'] === true) {


      nextState.selectedRows = 0
      nextState.keys = []
      return true;
    } else {
      wizNotice.error(nextProps['listByPage']['msg'])
      return false;
    }
  }
  _saveOnChange(nextProps, nextState) {
    if (nextProps['save'] && nextProps['save']['success'] === true) {


      this._selectPageInfo({ appInfoId: nextState?.record?.id || null });
      nextState.visible = false
      nextState.pageKey = new Date().getTime()
      return true;
    } else {
      wizNotice.error(nextProps['save']['msg'])
      return false;
    }
  }
  _deleteRecordOnChange(nextProps, nextState) {
    if (nextProps['deleteRecord'] && nextProps['deleteRecord']['success'] === true) {


      this._selectPageInfo({ appInfoId: nextState?.record?.id || null });
      nextState.visible = false
      nextState.pageKey = new Date().getTime()
      return true;
    } else {
      wizNotice.error(nextProps['deleteRecord']['msg'])
      return false;
    }
  }


  _renderTitleInfoRow(leftName, leftValue = '', rightName, rightValue = '') {
    return (
      <WizRow className='text_row'>
        <WizCol className='text_right' span={3} offset={0.5}>{leftName + '：'}</WizCol>
        <WizCol span={6}>{leftValue}</WizCol>
        <WizCol className='text_right' span={3} offset={2}>{rightName + '：'}</WizCol>
        <WizCol span={6}>{rightValue}</WizCol>
      </WizRow>
    )
  }
  _renderInfo() {
    let { record } = this.state
    return (
      <>
        <WizCard title={"应用基本信息"}>
        {this._renderTitleInfoRow('所属企业',  record?.corpInfoName,'应用id',  record?.appId )}
        {this._renderTitleInfoRow('应用名称',  record?.name,'备注',  record?.remark )}
        </WizCard>
      </>
    )
  }
    /**
   * 获取列表数据
   */
     _selectPageInfo(apiParams = {}) {
      this.doAction({
        path: "thirdAppSetting/listByPage",
        payload: {
          key: "thirdAppSetting@listByPage",
          apiParams: {  ...apiParams }
        }
      })
    }
    
  _onSelect(keys) {
    this.setState({
      keys,
      selectedRows: keys.length
    })
  }
  /**
   * 渲染操作按钮 且 进行权限检查
   */
   _renderBtn = (selectedRows, keys) => {
    let r = []
    let btns = new Map();
    btns.set('add',
      <WizButton title="新增" key={`addBtn`}
        icon='plus' type='primary'
        onClick={() => {
          this.setState({
            visible: true,
            editInfo:{},
          })
        }}
        style={{ marginBottom: 15 }}>新增</WizButton>
    );
    btns.set('delete',
      <WizButton title='删除' key={`deleteBtn`} type='danger' icon='delete'
        onClick={() => {

          WizModal.confirm({
            title: '注意',
            content: '删除后数据不可恢复，您确定要删除选中的数据吗？',
            onOk: () => {
              this.doAction({
                path: 'thirdAppSetting/delete',
                payload: {
                  key: 'thirdAppSetting@delete',
                  apiParams: {
                    ids: keys
                  }
                }
              })
            },
            onCancel() {
            }
          });
        }}
        disabled={selectedRows < 1}>删除</WizButton>);

    let btnCode = this.getMenuBtn() || [];
    //let btnCode =  ['add','delete'];
    btnCode.map(({ code }) => {
      if (btns.has(code)) {
        r.push(btns.get(code))
      }
    })
    r.push(btns.get("add"))
    r.push(btns.get("delete"))
    return r
  }
  
  _modalCancel = () => {
    this.setState({ visible: false })
  }
  
  // 提交
  onSubmit = values => {
    values.authCmd = formatAuth(values.authInfo)
     values.appInfoId = this?.state.record?.id || null
    delete values.authInfo
    let type = values?.id ?'update' :'add'
    
    this.doAction({
      path: `thirdAppSetting/${type}`,
      payload: {
        key: `thirdAppSetting@save`,
        apiParams: values
      }
    })
  }
  editSetting(record){
    this.setState({
      editInfo:record,
      visible:true
    })
  }
  _renderTable(){
    let { record,pageKey,selectedRows,keys,editInfo,visible  } = this.state
    let type = "listByPage"
    let dataItems = getPageData(this.props[type] && this.props[type].data)
    let columns = createColumns(this)
    let dataTableProps = {
      columns,
      rowKey: 'id',
      selectType: "checkbox",
      dataItems,
      showNum: false,
      // isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this._selectPageInfo({ current: pageNum, size: pageSize, appInfoId:record?.id })
      },
      // selectedRowKeys: [rows.map(item => item.rowKey)],
      onSelect: (keys, rows) => this._onSelect(keys)
    }
    const formProps = {
      ref: 'form',
      columns: createColumns(),
      onSubmit: this.onSubmit,
      onReset: (f) => {},
      key: editInfo?.id || 0,
      record: editInfo,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: {span: 4},
        wrapperCol: {span: 17}
      }
    }
    const modalProps = {
      visible,
      title: "新增",
      footer: null,
      onCancel: this._modalCancel,
    };
    return (
      
      <div className='renderSearchTable'>
        <WizCard title="应用权限配置">
        <WizCard className="panel-item">
            <div className='split-btns'>
              {this._renderBtn(selectedRows, keys)}
            </div>
            <WizDataTable key={'thirdAppSetting' + '_dataTable' + pageKey} {...dataTableProps} />
            <div className='pagination'>
              <WizDataTable.Pagination key={'thirdAppSetting' + '_pagination' + pageKey} {...dataTableProps} />
            </div>
          </WizCard>
        </WizCard>
        <WizModal {...modalProps}>
        <WizForm {...formProps} />
        </WizModal>
      </div>
    )
  }

  _render() {
    const {thirdAppSettingLoading} = this.props
    return (
      <>
        <WizSpin tip={"加载中"} spinning={false && thirdAppSettingLoading}>
          {this._renderInfo()}
          {this._renderTable()}
        </WizSpin>
      </>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
    const { thirdAppSetting } = state;
    const listByPage = modelUtils.getModelEntity(thirdAppSetting, 'thirdAppSetting@listByPage');
    const save =  modelUtils.getModelEntity(thirdAppSetting, 'thirdAppSetting@save'); 
    const deleteRecord  =  modelUtils.getModelEntity(thirdAppSetting, 'thirdAppSetting@delete'); 
    
    return {
      thirdAppSetting,
      listByPage,
      save,
      deleteRecord,
    }
};

export default connect(mapStateToProps)(ThirdAppAuthSetting);
